
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.779 1.496A.854.854 0 009 1a.854.854 0 00-.779.496l-2.125 4.6-4.6 2.125A.854.854 0 001 9c0 .336.193.64.496.779l4.6 2.125 2.125 4.6c.14.303.443.496.779.496s.64-.193.779-.496l2.125-4.6 4.6-2.125A.854.854 0 0017 9a.854.854 0 00-.496-.779l-4.6-2.125-2.125-4.6z","fill":"#6039FC"}})])
          )
        }
      }
    